export default __webpack_public_path__ + "static/media/63t.f8791b9d.jpg";